/**
 * Old and short paths that should land on a canonical route.
 *
 * `from` is matched exactly (case-insensitively, trailing slash ignored) and
 * the visitor is sent to `to` with a history *replace*, so the back button
 * doesn't bounce them straight back out.
 *
 * Two kinds of entry live here:
 *
 *  - Aliases: /terms and /privacy are convenient to type and to link
 *    internally, but the canonical URLs are the underscored ones the store
 *    listings already point at.
 *  - Legacy: anything an older build of the site used. Add to this list
 *    rather than repointing a canonical path — a URL that once worked should
 *    keep working, because someone has it bookmarked or in a support ticket.
 */
export const REDIRECTS: { from: string; to: string }[] = [
  { from: "/terms", to: "/terms_of_service" },
  { from: "/tos", to: "/terms_of_service" },
  { from: "/privacy", to: "/privacy_policy" },
  { from: "/policy", to: "/privacy_policy" },
  { from: "/conduct", to: "/rules_of_conduct" },
  { from: "/rules", to: "/rules_of_conduct" },
];

/** Normalises "/Terms/" and "/terms" to the same key. */
const normalise = (pathname: string) => {
  const trimmed = pathname.replace(/\/+$/, "").toLowerCase();
  return trimmed === "" ? "/" : trimmed;
};

/** The canonical path for `pathname`, or null if it's already canonical. */
export const redirectFor = (pathname: string): string | null => {
  const key = normalise(pathname);
  const hit = REDIRECTS.find((r) => normalise(r.from) === key);
  return hit ? hit.to : null;
};
